module.exports = __webpack_public_path__ + "static/media/ccard-master.d2a4eb58.svg";